module.exports = __webpack_public_path__ + "static/img/thumb-01.d2b0390.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/j_t/thumb/thumb-01.png
// module id = 4bf3
// module chunks = 150